import React from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function InspectionTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Type", field: "inspectionreporttype" },
    { label: "Category", field: "inspectionreportcategory" },
    { label: "Supplier Name", field: "suppliername" },
    { label: "Inspection Report No.", field: "inspectionreportno" },
    { label: "Job Number", field: "jobnumber" }, 
    { label: "Inspection Report Date", field: "inspectionreportdate" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"INSPECTION REPORT"}
        apiField={"inspectionReport"}
        // addButton={"+ ADD"}
        // createRoute={"/irCreate"}
        updateRoute={"/irView"}
        viewRoute={"/irView"}
      />
    </div>
  );
}

export default InspectionTable;
